/* 
 * @props isPopup: (boolean) - If passed as true, then component will be shown inside a modal
 * @props isPopupOpen: (boolean) - State of opening/closing of modal
 * @props onPopupCloseCb: (callback function) - Callback Function which will get called when the modal is closed
*/

import React, { useEffect, useState } from 'react'
import styles from "./AddRecipient.styles"
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setMethodType, setRecipientAddressInformation, setRecipientAddressInformationFieldsTouched, setRecipientBasicInformation, setRecipientBasicInformationFieldsTouched, setRecipientOptionalInformation, setRecipientOptionalInformationFieldsTouched, setRecipientType, setRequestType, setSelectedPayer } from './AddRecipientSlice';
import Loadable from '../../../components/loadable/Loadable';
import StepperNavigation from '../../../components/steppernavigation/StepperNavigation';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import GeneralValidator from '../../../../libs/utility/validators/GeneralValidator';
import { CHOOSE_METHOD_CARDS_RECIPIENT, CHOOSE_METHOD_CARD_NAMES } from '../addpayernew/createone/getmethod/constants/constants';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import GetMethod from '../addpayernew/createone/getmethod/GetMethod';
import GetRequestType from "./steps/getrequesttype/GetRequestType"
import GetBasicInfo from "./steps/getbasicinfo/GetBasicInfo";
import GetAddressInfo from "./steps/getaddressinfo/GetAddressInfo"
import GetOptionalInfo from "./steps/getoptionalinfo/GetOptionalInfo"
import GetPayerType from '../addpayernew/createone/getpayertype/GetPayerType';
import UploadFile from './bulkuploadsteps/uploadfile/UploadFile';
import { componentKey as bulkUploadComponentKey, setUploadedFile } from "./bulkuploadsteps/BulkUploadSlice"
import BulkUploadSuccess from './bulkuploadsteps/bulkuploadsuccess/BulkUploadSuccess';
import { getTemplate, validateSheetRecords } from './bulkuploadsteps/BulkUploadSaga';
import { RECIPIENT_SECTION_ROUTES } from '../../recipientssection/constants';
import Popup from '../../../components/popup/Popup';
import PayerDropdown from '../payerdropdown/PayerDropdown';
import { addRecipient } from './AddRecipientSaga';
import { componentKey as authenticationSliceKey } from '../../authentication/AuthenticationSlice';
import AddRecipientSuccess from './addrecipentsuccess/AddRecipientSuccess';
import W8W9PaymentModals from './w8w9paymentmodals/W8W9PaymentModals';
import { QUERY_PARAMS } from '../../formssection/constants';
import GetRecipientType from './getrecipienttype/GetRecipientType';
import { RECIPIENT_TYPE_TITLE } from './getrecipienttype/constants';
import { VALIDATE_NAME_REGEX, VALIDATE_ZIP_CODE_REGEX } from '../../../../libs/utility/constants';
import useTxSearchParams from '../../../../libs/txsearchparams/TxSearchParamsHook';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';
import { RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, SPACE_NOT_ALLOWED_IN_RECIPIENT_CLIENT_ID_TEXT } from '../../constants/constants';
import { ADD_RECIPIENT_LOADING_STATES, ADD_RECIPIENT_MESSAGE_MAP } from './constant';
import {componentKey as dataLoaderComponentKey} from '../../loaders/dataloader/DataLoaderSlice';
import { getCountriesAndStatesList } from '../../loaders/dataloader/DataLoaderSaga';
import Recipient from '../../../../libs/utility/Recipient';

export default function AddRecipient({ isPopup = false, isPopupOpen = false, onPopupCloseCb = () => { }, onFinalSubmitCb = () => { }, defaultSelectedPayer = { label: "", value: "" }, onChangePayerDropdownCb = () => { }, hidePayerSelectionStep = false, is1042SForm = false, fromFormModule = false }) {

    useGarbageCollector(componentKey);

    const navigate = useTxNavigate();
    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();

    const { uploadedFile } = useSelector((state) => state[bulkUploadComponentKey]);
    const { signedInUser } = useSelector(state => state[authenticationSliceKey])
    const { countriesList, statesList } = useSelector((state) => state[dataLoaderComponentKey]);

    const recipientData = useSelector(state => state[componentKey]);
    const { loadingState, methodType, RecipientType, RequestType, recipientBasicInfo, recipientAddressInformation, recipientOptionalInformation, zipCodeValidationSuccess, recipientCreationSuccessful, selectedPayer, submittedRecipient, W8W9Fees } = recipientData;

    const [refreshStep, setRefreshStep] = useState(0);
    const { tinTooltip, tinPlaceholder, tinValue, tinRules, showNames, tinDisabled } = Recipient.getTINProps(RecipientType, recipientBasicInfo.RecipientTIN?.value, RequestType, recipientBasicInfo?.tinNotProvided);

    useEffect(() => {
        dispatch(setRecipientOptionalInformation({
            Isrecipientclient: {
                value: "",
                errors: {},
                rules: { required: signedInUser?.IsRecipientClient ? true : false, maxLength: 40, regex: { pattern: RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, message:  SPACE_NOT_ALLOWED_IN_RECIPIENT_CLIENT_ID_TEXT} }
            }
        }))
    }, []);

    useEffect(() => {
        if (!RequestType) {
            const USA = countriesList?.find(country => country?.Country_code === "US")
            dispatch(setRecipientAddressInformation({ RecipientCountry: USA }));
        }
    }, []);

    useEffect(() => {
        if (countriesList.length <= 0 || statesList.length <= 0) {
            dispatch(getCountriesAndStatesList())
        };
    }, [])

    useEffect(() => {
        if (defaultSelectedPayer?.PayerDetailId) {
            dispatch(setSelectedPayer(defaultSelectedPayer));
            queryParams.set(QUERY_PARAMS.PAYER_ID, defaultSelectedPayer.PayerDetailId);
            setQueryParams(queryParams);
        }
    }, [defaultSelectedPayer]);

    useEffect(() => {
        if (recipientCreationSuccessful) {
            if (isPopup) {
                setRefreshStep(0);
                onFinalSubmitCb();
                onPopupCloseCb();
            }
        }
    }, [recipientCreationSuccessful])

    useEffect(() => {
        if (RecipientType === RECIPIENT_TYPE_TITLE.BUSINESS) {
            dispatch(setRecipientBasicInformation({
                RecipientFirstName: {
                    value: "",
                    errors: {},
                    rules: { required: false }
                },
            }));

            dispatch(setRecipientBasicInformation({
                RecipientMiddleName: {
                    value: "",
                    errors: {},
                    rules: { required: false }
                },
            }))
        } else {
            dispatch(setRecipientBasicInformation({
                RecipientFirstName: {
                    value: "",
                    errors: {},
                    rules: { required: false, regex: { pattern: VALIDATE_NAME_REGEX, message: "A valid recipient name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character" } }
                },
            }));
            dispatch(setRecipientBasicInformation({
                RecipientMiddleName: {
                    value: "",
                    errors: {},
                    rules: { required: false, regex: { pattern: VALIDATE_NAME_REGEX, message: "A valid recipient name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character" } }
                },
            }));
        }
        dispatch(setRecipientBasicInformation({
            RecipientTIN: {
                rules: {...tinRules}
            }
        }));
    }, [RecipientType])

    useEffect(() => {
        if (recipientAddressInformation.RecipientCountry.value !== "US") {
            dispatch(setRecipientAddressInformation({
                RecipientState: {
                    label: "",
                    value: "",
                    errors: {},
                    rules: { required: false }
                },
            }));

            dispatch(setRecipientAddressInformation({
                RecipientZIP: {
                    value: "",
                    errors: {},
                    rules: {}
                }
            }));
        } else if (recipientAddressInformation.RecipientCountry.value === "US") {
            dispatch(setRecipientAddressInformation({
                RecipientState: {
                    label: "",
                    value: "",
                    errors: {},
                    rules: { required: true }
                },
            }));

            dispatch(setRecipientAddressInformation({
                RecipientZIP: {
                    value: "",
                    errors: {},
                    rules: { required: true, regex: { pattern: VALIDATE_ZIP_CODE_REGEX, message: "Please enter a valid ZIP Code. The ZIP Code should only contain numbers" } }
                },
            }));
        }
    }, [recipientAddressInformation?.RecipientCountry.value])

    useEffect(() => {
        dispatch(setRecipientBasicInformation({ ["RecipientEmail"]: { rules: { required: RequestType ? true : false } } }));
    }, [RequestType]);

    useEffect(() => {
        const isRequiredField = RequestType ? false : true
        const addressFieldsRules = {
            RecipientAddress: {
                rules: {
                    ...recipientAddressInformation.RecipientAddress.rules,
                    required: isRequiredField
                }
            },
            RecipientCountry: {
                rules: {
                    ...recipientAddressInformation.RecipientCountry?.rules,
                    required: isRequiredField
                }
            },
            RecipientState: {
                rules: {
                    ...recipientAddressInformation.RecipientState?.rules,
                    required: isRequiredField
                }
            },
            RecipientCity: {
                rules: {
                    ...recipientAddressInformation.RecipientCity?.rules,
                    required: isRequiredField
                }
            },
            RecipientZIP: {
                rules: {
                    ...recipientAddressInformation.RecipientZIP?.rules,
                    required: isRequiredField
                }
            }
        }
        const basicInfoFieldsRules = {
            RecipientLastName: {
                rules: {
                    ...recipientBasicInfo.RecipientLastName?.rules,
                    required: isRequiredField
                }
            },
            RecipientTIN: {
                rules: {...tinRules}
            }
        }
        dispatch(setRecipientAddressInformation(addressFieldsRules))
        dispatch(setRecipientBasicInformation(basicInfoFieldsRules))
    }, [RequestType])

    const GET_METHOD_STEP = [
        ...( hidePayerSelectionStep ? [] : [{
            title: "Select Payer",
            stepBodyComponent:
                <PayerDropdown
                    selectPayerDropdownProps={{
                        selectedValue: selectedPayer?.PayerDetailId ? selectedPayer : defaultSelectedPayer,
                        onSelectCb: (selectedPayerVal) => {
                            dispatch(setSelectedPayer(selectedPayerVal));
                            onChangePayerDropdownCb(selectedPayerVal);
                        }
                    }}
                />,
                ...(!isPopup
                    ? {
                        backButtonText: "Back",
                        prevCb: () => {
                          navigate(`/${RECIPIENT_SECTION_ROUTES.RECIPIENT}`);
                        },
                      }
                    : {}),
            submitButtonText: "Next",
            submitButtonDisabled: selectedPayer?.PayerDetailId ? false : true,
            submitButtonDisabledInfoCb: () => {
                dispatch(addNotifications({ heading: "Please select the payer.", message: "To continue, please select the payer" }))
            },
            submitCb: () => { },
        }]),
        {
            title: "Select Method",
            stepBodyComponent: <Loadable isNewLoadable={true} currentState={loadingState.state} loadingStates={[ADD_RECIPIENT_LOADING_STATES.GET_TEMPLATE_LOADING]} messageMap={ADD_RECIPIENT_MESSAGE_MAP} >
                <GetMethod
                    onCardClickCb={(card) => dispatch(setMethodType(card.name))}
                    methodType={methodType}
                    heading="How would you like to add your recipients?"
                    cardsData={CHOOSE_METHOD_CARDS_RECIPIENT}
                    onClickLinkButtonTextCb={() => dispatch(getTemplate())}
                />
            </Loadable>,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitButtonDisabled: methodType ? false : true,
            submitButtonDisabledInfoCb: () => {
                dispatch(addNotifications({ heading: "Please choose a method", message: "To continue, please select how would you like to add your recipients?" }))
            },
            submitCb: () => { },
        }
    ]

    const CREATE_ONE_STEPS = [
        // If we are adding a recipient from 1042-S form, then selection of W-8 or W-9 request is not visible
        ...(fromFormModule ? [] : [{
            title: "Type of Request",
            stepBodyComponent: <GetRequestType onCardClickCb={(card) => dispatch(setRequestType(RequestType == card.title ? '' : card.title))} type={RequestType} />,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitCb: () => { },
        }]),
        {
            title: "Type of Recipient",
            stepBodyComponent: <GetRecipientType
                onCardClickCb={(card) => {
                    if (!RequestType) {
                        dispatch(setRecipientType(RecipientType == card.title ? '' : card.title))
                    } else {
                        dispatch(setRecipientType(card.title))
                    }
                }}
                type={RecipientType}
                heading={`How would you describe this recipient? ${!RequestType ? '' : '(optional)'}`}
                description="A recipient is someone who receives income or payments subject to taxation."
                is1042SForm={is1042SForm}
            />,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitButtonDisabled: (RequestType || RecipientType) ? false : true,
            submitButtonDisabledInfoCb: () => {
                dispatch(addNotifications({ heading: "Please select the type of recipient", message: "To continue, please select the type of recipient" }))
            },
            submitCb: () => { },
        },
        {
            title: "Basic Information",
            stepBodyComponent: <GetBasicInfo />,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitButtonDisabled: GeneralValidator.validateRequiredFields(recipientBasicInfo) ? true : false,
            submitButtonDisabledInfoCb: () => {
                dispatch(setRecipientBasicInformationFieldsTouched(true))
                dispatch(addNotifications({ heading: "Error", message: "Please enter valid data" }))
            },
            submitCb: () => { },
        },
        {
            title: "Address Information",
            stepBodyComponent: <GetAddressInfo />,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitButtonDisabled: GeneralValidator.validateRequiredFields(recipientAddressInformation) || !zipCodeValidationSuccess ? true : false,
            submitButtonDisabledInfoCb: () => {
                dispatch(setRecipientAddressInformationFieldsTouched(true));

                if (GeneralValidator.validateRequiredFields(recipientAddressInformation)) {
                    dispatch(addNotifications({ heading: "Please enter valid data", message: "To continue, please enter the valid address data" }))
                } else if (!zipCodeValidationSuccess) {
                    dispatch(addNotifications({ heading: "Please validate the zip code", message: "To continue, please enter the valid zip code and click on next" }))
                }
            },
            submitCb: () => { },
        },
        {
            title: "Optional Information",
            stepBodyComponent: <GetOptionalInfo />,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitButtonDisabled: GeneralValidator.validateRequiredFields(recipientOptionalInformation) ? true : false,
            submitButtonDisabledInfoCb: () => {
                dispatch(setRecipientOptionalInformationFieldsTouched(true))
                dispatch(addNotifications({ heading: "Please enter valid data", message: "To continue, please enter the valid data" }))
            },
            submitCb: () => { dispatch(addRecipient({ ...recipientData, is1042SForm })) },
        }
    ];

    const BULK_UPLOAD_STEPS = [
        {
            title: "Upload file",
            stepBodyComponent: <Loadable isNewLoadable={true} currentState={loadingState.state} loadingStates={[ADD_RECIPIENT_LOADING_STATES.BULK_UPLOAD_SHEET_LOADING]} messageMap={ADD_RECIPIENT_MESSAGE_MAP} >
                <UploadFile />
            </Loadable>,
            discardCb: () => { },
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitCb: () => dispatch(validateSheetRecords({ payerId: selectedPayer?.PayerDetailId })),
            submitButtonDisabled: !uploadedFile,
            submitButtonDisabledInfoCb: () => {
                dispatch(addNotifications({ heading: "Error", message: "Please upload a file to continue" }))
            },
        },
        {
            title: "Bulk Upload Status",
            stepBodyComponent: <Loadable isNewLoadable={true} currentState={loadingState.state} loadingStates={[ADD_RECIPIENT_LOADING_STATES.VALIDATE_BULK_UPLOAD_SHEET_RECORD_LOADING]} messageMap={ADD_RECIPIENT_MESSAGE_MAP} >
                <BulkUploadSuccess setRefreshStep={(idx) => setRefreshStep(idx)} />
            </Loadable>,
            backButtonText: "Back",
            prevCb: () => {
                dispatch(setUploadedFile(null));
                setRefreshStep(1)
            },
        },
    ];

    let steps = GET_METHOD_STEP;

    switch (methodType) {
        case CHOOSE_METHOD_CARD_NAMES.CREATE_ONE:
            steps = [...GET_METHOD_STEP, ...CREATE_ONE_STEPS];
            break;

        case CHOOSE_METHOD_CARD_NAMES.BULK_UPLOAD:
            steps = [...GET_METHOD_STEP, ...BULK_UPLOAD_STEPS];
            break;
    }

    const AddRecipientJSX = (
        <div style={styles.recipientContainer}>
            <Loadable isNewLoadable={true} currentState={loadingState.state} loadingStates={[ADD_RECIPIENT_LOADING_STATES.SAVE_RECIPIENT_LOADING]} messageMap={ADD_RECIPIENT_MESSAGE_MAP} >
                {recipientCreationSuccessful ? <AddRecipientSuccess setRefreshStep={setRefreshStep} /> : <StepperNavigation steps={steps} refreshStep={refreshStep} setRefreshStep={(idx) => setRefreshStep(idx)} customStepperBodyContainerStyles={{ height: "auto" }}
                    customFooterBodyContainer={{ marginTop: "10px" }} applyMaxHeightToBodyContainer={"55vh"} />}

                <W8W9PaymentModals
                    submittedRecipient={submittedRecipient}
                    requestType={RequestType}
                    recipientIds={submittedRecipient?.RecipentDetailId}
                    payerId={submittedRecipient?.PayerId}
                    W8W9Fees={W8W9Fees}
                />

            </Loadable>
        </div>
    )

    return (
        <>
            {isPopup ?

                <Popup title={""} onCloseCb={onPopupCloseCb} isPopupOpen={isPopupOpen} customPopupSyles={styles.popupStyles} overlayStyles={styles.popupoOverlay} childrenStyles={styles.popupChildrenStyles}>
                    {AddRecipientJSX}
                </Popup>

                :

                AddRecipientJSX
            }
        </>
    )
}